import { Box, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
// import DrawerAppBar from "./AppBarOld";
import AppBar from "./AppBar";
import PoweredBy from "./PoweredBy";

export default function Layout() {
  return (
    <Stack flexDirection="column">
      <AppBar />
      <Box
        component="main"
        mx="auto"
        maxWidth="70rem"
        width="100%"
        minHeight="80dvh"
      >
        <Outlet />
      </Box>
      <PoweredBy />
    </Stack>
  );
}
